import { cx } from 'class-variance-authority'

export const ProgressBar = ({ width, backgroundColor, tooltipMessage }) => {
  return (
    <div className="group relative">
      <div className="w-full cursor-help overflow-hidden rounded bg-gray-200">
        <div
          className={cx(
            backgroundColor,
            'h-4 p-0.5 text-center text-xs font-medium leading-none text-slate-500',
          )}
          style={{ width: `${width <= 100 ? width : 100}%` }}
        ></div>
      </div>
      <div className="z-90 absolute -left-20 -top-[5.5rem] hidden min-h-[80px] min-w-[250px] rounded bg-slate-500 px-4 py-2 opacity-95 shadow-lg group-hover:block">
        <p className="text-left text-white"> {tooltipMessage} </p>
      </div>
    </div>
  )
}
